export default __webpack_public_path__ + "static/media/6307 - 12GAUGE.76845de0.jpeg";